'use client';

import { useEffect } from 'react';

// Meta Pixel utility class
class MetaPixelTracker {
  
  // Track ViewContent event (for location pages)
  static trackViewContent(contentData?: {
    contentType?: string;
    contentIds?: string[];
    contentName?: string;
    value?: number;
    currency?: string;
  }) {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent', contentData);
      console.log('[Meta Pixel] ViewContent tracked:', contentData);
    }
  }

  // Track Lead event (for Get Started / Get The App clicks)
  static trackLead(leadData?: {
    contentName?: string;
    value?: number;
    currency?: string;
  }) {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead', leadData);
      console.log('[Meta Pixel] Lead conversion tracked:', leadData);
    }
  }

  // Track custom events
  static trackCustomEvent(eventName: string, parameters?: Record<string, any>) {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', eventName, parameters);
      console.log('[Meta Pixel] Custom event tracked:', eventName, parameters);
    }
  }
}

// Extend the global Window interface
declare global {
  interface Window {
    fbq?: (action: string, event: string, parameters?: Record<string, any>) => void;
    MetaPixelTracker?: typeof MetaPixelTracker;
    _fbq_pixel_427953549859506?: boolean;
  }
}

// Component to expose MetaPixelTracker globally
function MetaPixelTrackerComponent() {
  useEffect(() => {
    // Expose MetaPixelTracker globally for easy access
    if (typeof window !== 'undefined') {
      window.MetaPixelTracker = MetaPixelTracker;
    }

    // Cleanup function
    return () => {
      if (typeof window !== 'undefined') {
        window.MetaPixelTracker = undefined;
      }
    };
  }, []);

  return null; // This component doesn't render anything
}

export default MetaPixelTrackerComponent;
export { MetaPixelTracker }; 